import React, { useState } from 'react';
import { useTranslate } from '@im/react-localization';
import Skeleton from '@mui/material/Skeleton';
import ExpandMoreOutlinedIcon from '@mui/icons-material/ExpandMoreOutlined';
import Stack from '@mui/material/Stack';
import Select from '@mui/material/Select';
import MenuItem from '@mui/material/MenuItem';
import LabeledField from 'src/components/Form/LabeledField';
import Box from '@mui/material/Box';

type AttrValueType = {
  attributeValue: string;
  id: number;
};
type ProgramAttrType = {
  attributeName: string;
  attributeValues: AttrValueType[];
  id?: number;
  itemId?: string;
};
type AttributeValueType = {
  initialData: {
    attributeName: string;
    attributeValue: string;
  };
  isLoading?: boolean;
  onChange: (event: any, value: any) => void;
  programAttrs: ProgramAttrType[];
  selectedAttrs?: string[];
};
const AttributeValue = ({
  initialData,
  isLoading = false,
  onChange,
  programAttrs,
  selectedAttrs,
}: AttributeValueType) => {
  const translate = useTranslate();
  const [programAttribute, setProgramAttribute] = useState(initialData);
  const [programAttrValues, setProgramAttrValues] = useState<AttrValueType[]>(
    []
  );
  const handleOnChangeAttribute = (event: any) => {
    setProgramAttrValues(
      programAttrs?.filter(
        (pa: ProgramAttrType) => pa.attributeName === event?.target?.value
      )[0].attributeValues
    );
    setProgramAttribute({
      ...programAttribute,
      attributeName: event?.target?.value,
    });
    onChange(event, {
      ...programAttribute,
      attributeName: event?.target?.value,
    });
  };
  const handleOnChangeValue = (event: any) => {
    setProgramAttribute({
      ...programAttribute,
      attributeValue: event?.target?.value,
    });
    onChange(event, {
      ...programAttribute,
      attributeValue: event?.target?.value,
    });
  };
  const programAttrsSkeleton = (
    <>
      <Skeleton height={72} variant="rectangular" width={250} />
      <Skeleton height={72} variant="rectangular" width={250} />
    </>
  );
  const getUnselectedAttrs = (item: any) =>
    programAttribute.attributeValue === item.attributeValue ||
    !selectedAttrs?.includes(
      `${programAttribute.attributeName}-${item.attributeValue}`
    );
  return (
    <Stack alignItems={'center'} direction="row" gap={2}>
      {isLoading ? (
        programAttrsSkeleton
      ) : (
        <>
          <Box minWidth={250}>
            <LabeledField label={translate('Pricing.ProgramAttribute')}>
              <Select
                IconComponent={ExpandMoreOutlinedIcon}
                onChange={handleOnChangeAttribute}
                sx={{ height: '35px', width: '100%' }}
                value={programAttribute.attributeName}
              >
                {programAttrs?.map((option: any, i: number) => (
                  <MenuItem
                    key={option.attributeName}
                    value={option.attributeName}
                  >
                    {option.attributeName}
                  </MenuItem>
                ))}
              </Select>
            </LabeledField>
          </Box>
          <Box minWidth={250}>
            <LabeledField label={translate('Pricing.ProgramValue')}>
              <Select
                IconComponent={ExpandMoreOutlinedIcon}
                onChange={handleOnChangeValue}
                sx={{ height: '35px', width: '100%' }}
                value={programAttribute.attributeValue}
              >
                {programAttrValues
                  .filter(getUnselectedAttrs)
                  .map((option: any, i: number) => (
                    <MenuItem
                      key={option.attributeValue}
                      value={option.attributeValue}
                    >
                      {option.attributeValue}
                    </MenuItem>
                  ))}
              </Select>
            </LabeledField>
          </Box>
        </>
      )}
    </Stack>
  );
};
export default AttributeValue;
